import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { db, auth } from './firebase';
import { useAuth } from './AuthContext';
import ProductCard from './ProductCard';
import ProductDetail from './ProductDetail';
import AddProduct from './AddProduct';
import UserManagement from './UserManagement';
import './Dashboard.css';

function Dashboard() {
  const [productos, setProductos] = useState([]);
  const [user, setUser] = useState(null);
  const [showAddProduct, setShowAddProduct] = useState(false);
  const [showUserManagement, setShowUserManagement] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [filterDisponible, setFilterDisponible] = useState(true);
  const { isAdmin } = useAuth();
  const { id } = useParams();
  const [selectedProduct, setSelectedProduct] = useState(null);

  useEffect(() => {
    // Obtener datos del usuario actual
    const unsubscribeAuth = auth.onAuthStateChanged((currentUser) => {
      if (currentUser) {
        setUser(currentUser);
      }
    });

    // Escuchar cambios en productos - OPTIMIZADO
    let q;
    if (filterDisponible) {
      // Solo cargar disponibles (más rápido)
      q = query(
        collection(db, 'productos'), 
        where('disponible', '==', true)
      );
    } else {
      // Cargar todos
      q = query(collection(db, 'productos'));
    }

    const unsubscribeProducts = onSnapshot(q, (snapshot) => {
      const productosData = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setProductos(productosData);
    });

    return () => {
      unsubscribeAuth();
      unsubscribeProducts();
    };
  }, [filterDisponible]);

  // Abrir producto si hay ID en la URL
  useEffect(() => {
    if (id && productos.length > 0) {
      const producto = productos.find(p => p.id === id);
      if (producto) {
        setSelectedProduct(producto);
      }
    }
  }, [id, productos]);

  const filteredProductos = productos.filter(producto => {
    const matchesSearch = searchText === '' || 
      producto.modelo.toLowerCase().includes(searchText.toLowerCase()) ||
      producto.marca.toLowerCase().includes(searchText.toLowerCase());
    
    return matchesSearch;
  });

  return (
    <div className="dashboard">
      <header className="dashboard-header">
        <div className="header-content">
          <div className="header-left">
            <img src="/logo.png" alt="JASAM" className="header-logo" />
            <div>
              <h1>JASAM INVENTARIO</h1>
              {user && <p>{user.email}</p>}
            </div>
          </div>
          <div className="header-right">
            {isAdmin() && (
              <>
                <button 
                  className="users-btn" 
                  onClick={() => setShowUserManagement(true)}
                  title="Gestión de Usuarios"
                >
                  👥
                </button>
                <button className="logout-btn" onClick={() => auth.signOut()}>
                  Cerrar Sesión
                </button>
              </>
            )}
          </div>
        </div>

        <div className="search-bar">
          <input
            type="text"
            placeholder="Buscar teléfonos..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
      </header>

      <div className="filter-bar">
        <div className="filters">
          <button
            className={filterDisponible ? 'active' : ''}
            onClick={() => setFilterDisponible(true)}
          >
            Disponibles
          </button>
          <button
            className={!filterDisponible ? 'active' : ''}
            onClick={() => setFilterDisponible(false)}
          >
            Todos
          </button>
        </div>

        {isAdmin() && (
          <button className="add-btn" onClick={() => setShowAddProduct(true)}>
            + Agregar Producto
          </button>
        )}
      </div>

      <div className="products-grid">
        {filteredProductos.length === 0 ? (
          <div className="empty-state">
            <p>📱 No hay productos</p>
            {isAdmin() && (
              <button onClick={() => setShowAddProduct(true)}>
                Agregar primer producto
              </button>
            )}
          </div>
        ) : (
          filteredProductos.map(producto => (
            <ProductCard key={producto.id} producto={producto} />
          ))
        )}
      </div>

      {showAddProduct && (
        <AddProduct onClose={() => setShowAddProduct(false)} />
      )}

      {showUserManagement && (
        <UserManagement onClose={() => setShowUserManagement(false)} />
      )}

      {selectedProduct && (
        <ProductDetail 
          producto={selectedProduct} 
          onClose={() => setSelectedProduct(null)} 
        />
      )}
    </div>
  );
}

export default Dashboard;